export function formatTimezoneLabel(timeZone: string): string {
  try {
    const offset =
      new Intl.DateTimeFormat('en-US', { timeZone, timeZoneName: 'shortOffset' })
        .formatToParts(new Date())
        .find((part) => part.type === 'timeZoneName')?.value ?? '';
    const name = timeZone.replaceAll('_', ' ');
    return offset ? `${name} (${offset})` : name;
  } catch {
    return timeZone;
  }
}
